import React, { memo, useCallback, useEffect, useMemo, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useEventSource } from '../../../../../hooks/useEventSource/useEventSource'
import {
  addTimeLineItem,
  updateTimeLineItem,
  deleteTimeLineItem,
} from '../../../../../store/timeline/actions'
import {
  ActivityItem,
  ActivityItems,
  ActivityTimelineContextProps,
  ActivityTimelineSync as ActivityTimeline,
  ActivityTimelineContext,
  selectTimelineData,
  selectTimelineError,
  selectTimelineIsLoading,
} from '../../../../../components/v2/activity-timeline'
import { useAppDispatch } from '../../../../../hooks/useAppDispatch/useAppDispatch'

interface timeLineProps {
  className?: string
  id: string | number
  hideHeader?: boolean
}

export const CardTimeline: React.FC<timeLineProps> = memo((props: timeLineProps) => {
  const { id, className, hideHeader } = props
  const dispatch = useAppDispatch()
  const timelineIsLoading = useSelector(selectTimelineIsLoading)
  const timelineError = useSelector(selectTimelineError)
  const timelineItems = useSelector(selectTimelineData)
  const { sse, subscribe } = useEventSource()

  const timelineItemsRef = useRef(timelineItems)

  useEffect(() => {
    timelineItemsRef.current = timelineItems
  }, [timelineItems])

  const handleTimelineNewItems = useCallback(
    (newItems: ActivityItems[]) => {
      /*
      todo из-за манго колхозим проверку на соответствие type и id передаваемых и существующих элементов,
       подумать как оптимизировать
      */
      newItems.forEach(newItem => {
        const currentTimelineItems = timelineItemsRef.current
        const scopeIndex = currentTimelineItems.itemsDates?.findIndex(date => date == newItem.date)

        if (scopeIndex === -1 || scopeIndex === undefined) {
          dispatch(addTimeLineItem([newItem]))
          return
        }
        if (!newItem?.items?.length) {
          return
        }

        const addItems: ActivityItem[] = []
        const updItems: ActivityItem[] = []

        for (const newItemByType of newItem.items) {
          const newItemId = newItemByType.data?.id || newItemByType.id
          let isExisting = false
          for (const currentItemByType of currentTimelineItems.items[scopeIndex]?.items) {
            const currentItemId = currentItemByType.data?.id || currentItemByType.id
            if (newItemByType.type === currentItemByType.type && newItemId === currentItemId) {
              updItems.push(newItemByType)
              isExisting = true
              break
            }
          }
          if (!isExisting) {
            addItems.push(newItemByType)
          }
        }

        if (addItems.length) {
          dispatch(addTimeLineItem([{ date: newItem.date, items: addItems }]))
        }

        if (updItems.length) {
          updItems.forEach(item => {
            dispatch(updateTimeLineItem({ date: newItem.date, type: item.type, data: item.data }))
          })
        }
      })
    },
    [dispatch],
  )

  useEffect(() => {
    subscribe(`/api/get-activity/live/claim_work/${id}`, handleTimelineNewItems)
    return () => sse?.current?.close()
  }, [id, subscribe, handleTimelineNewItems])

  const updateTimeline = useCallback(activityItem => {
    dispatch(updateTimeLineItem(activityItem))
  }, [])

  const deleteTimelineItem = useCallback(activityItem => {
    dispatch(deleteTimeLineItem(activityItem))
  }, [])

  const defaultProps = useMemo(
    (): ActivityTimelineContextProps => ({
      card_id: id,
      card_type: 'claim_work',
      updateTimeline: updateTimeline,
      deleteTimelineItem: deleteTimelineItem,
    }),
    [id],
  )

  return (
    <ActivityTimelineContext.Provider value={defaultProps}>
      <ActivityTimeline
        isLoading={timelineIsLoading}
        items={timelineItems?.items}
        error={timelineError}
        className={className}
        hideHeader={hideHeader}
      />
    </ActivityTimelineContext.Provider>
  )
})
